import React, { memo } from 'react';

import LineChart, { LineChartProps } from './LineChart/LineChart';

const SpendingChart = ({ data }: LineChartProps) => {
  return <LineChart data={data} />;
};

export default memo(SpendingChart);
